import { render, staticRenderFns } from "./GBDayFreePerson.vue?vue&type=template&id=3c57e9c8&"
import script from "./GBDayFreePerson.vue?vue&type=script&lang=js&"
export * from "./GBDayFreePerson.vue?vue&type=script&lang=js&"
import style0 from "./GBDayFreePerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports